import script from "./JobSearchFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./JobSearchFooter.vue?vue&type=script&lang=ts&setup=true"

import "./JobSearchFooter.vue?vue&type=style&index=0&id=c8868c46&lang=scss"

const __exports__ = script;

export default __exports__